import * as React from "react";
function SvgTagUser(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M14.96 31H4.1L2.04 20.57 17.04 2l12.91 10.43-2.01 2.5"
      />
      <path d="M9.83 22.5a1 1 0 11-1 1 1 1 0 011-1m0-2a3 3 0 103 3 3 3 0 00-3-3z" />
      <circle
        cx={24.9}
        cy={20.46}
        r={3.88}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M22.19 31H18.8A6.1 6.1 0 0131 31h-3.39"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTagUser);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
